module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    class: [{
      'low-opacity': this.activeContent !== 'pt'
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": this.$config.imgDir + '/flag-brazil-32.png'
    },
    on: {
      "click": _vm.showPtContent
    }
  }), _vm._v(" "), _c('img', {
    class: [{
      'low-opacity': this.activeContent !== 'en'
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": this.$config.imgDir + '/flag-usa-32.png'
    },
    on: {
      "click": _vm.showEnContent
    }
  })]), _vm._v(" "), _c('div', [(this.activeContent === 'pt') ? _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Texto em Portugês")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body pad"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.pageContent.portugueseBody,
      "height": 300
    },
    on: {
      "change": _vm.updatePortugueseData
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (this.activeContent === 'en') ? _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Texto em Inglês")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body pad"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.pageContent.englishBody,
      "height": 300
    },
    on: {
      "change": _vm.updateEnglishData
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('notifier', {
    ref: "notifier"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-585329fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cms/Cms.vue
// module id = 675
// module chunks = 1